import { SubmissionError } from 'redux-form';

import _isNil from 'lodash/fp/isNil';
import _pathOr from 'lodash/fp/pathOr';
import _pick from 'lodash/fp/pick';

import http from '../../../../shared/http';
import endpoints from '../../../../../config/endpoints';
import {
	createSelectOptionsFromSysEnums
} from '../../../../shared/form-elements/select';

import {actions as parentActions} from '../../../editor';

const defaultInitialState = {
	currentLanguage: 'en',
	fileToUpload: null,
	fields: {
		name: '',
		description: '',
		category: '',
		currency: '',
		price: '',
		available_amount: '',
		translations: {
			ru: {
				name: '',
				description: ''
			},
			de: {
				name: '',
				description: ''
			},
			vi: {
				name: '',
				description: ''
			},
			th: {
				name: '',
				description: ''
			}
		}
	}
};

const errorReducerFn = (state, action) => {
	if (action.payload.response.status !== 400) {
		return ({ ...state, error: true, showProgressBar: false });
	}
	return state;
};

const prepareFormErrors = errors => {
	const validationsErrors = {};
	errors.forEach(value => {
		if (value.dataPath.length === 0) {
			const key = value.message.substring(value.message.lastIndexOf(' ') + 1);
			validationsErrors[key] = value.message;
		} else {
			const key = value.dataPath.slice(1);
			validationsErrors[key] = value.message;
		}
	});
	return validationsErrors;
};

const createGeneralForm = ({
	namespace, stateNodeName
}) => {

	const MAIN_FORM_SUBMIT_SUCCESS = `${namespace}/${stateNodeName}-submit-success`;
	const MAIN_FORM_SUBMIT_ERROR = `${namespace}/${stateNodeName}-submit-error`;

	const MAIN_FORM_UPLOAD_SUCCESS = `${namespace}/${stateNodeName}-upload-success`;
	const MAIN_FORM_UPLOAD_ERROR = `${namespace}/${stateNodeName}-upload-error`;
	const MAIN_FORM_PREPARATION_FILE = `${namespace}/${stateNodeName}-preparation-file-success`;
	const MAIN_FORM_CHANGE_LANGUAGE = `${namespace}/${stateNodeName}-change-language`;

	const initialState = {
		...defaultInitialState
	};

	const actions = {
		mainFormSubmit: formData => (dispatch, getState) => {
			const { data } = getState().bmAccountsEditor;
			const url = data.id ? `${endpoints.BM_ACCOUNTS.BASE}/${data.id}` : endpoints.BM_ACCOUNTS.BASE;

			const submitData = {
				...data,
				category_id: _pathOr(null, ['category', 0, 'value'])(formData),
				currency: _pathOr('usd', ['currency', 0, 'value'])(formData),
				..._pick([
					'name', 'description', 'price', 'translations', 'translations', 'available_amount'
				])(formData)
			};
			const request = http({
				url,
				method: !_isNil(data.id) ? 'put' : 'post',
				actions: [ MAIN_FORM_SUBMIT_SUCCESS, MAIN_FORM_SUBMIT_ERROR],
				data: submitData
			});
			dispatch(parentActions.toggleProgressBar());

			return request(dispatch)
				.then( async action => {
					if (action.type === MAIN_FORM_SUBMIT_SUCCESS) {
						dispatch(parentActions.toggleProgressBar());
						const { fileToUpload } = getState().bmAccountsEditor.mainForm;

						if (fileToUpload) {
							await actions.uploadFile(action.payload.data.id, fileToUpload, dispatch);
						}

						dispatch(parentActions.fetchData(action.payload.data.id));
					}
					if (action.type === MAIN_FORM_SUBMIT_ERROR && action.payload.response.status === 400) {
						const responseErrors = action.payload.response.data;
						throw new SubmissionError(prepareFormErrors(responseErrors));
					}

				});
		},

		mainFormChangeLanguage: lang => dispatch => {
			return dispatch({ type: MAIN_FORM_CHANGE_LANGUAGE, payload: lang });
		},

		preparationFile: (file, nextAction) => dispatch => {
			const reader = new FileReader();
			const data = new FormData();

			data.append('image', file);

			reader.readAsDataURL(file);
			reader.onloadend = function () {
				nextAction(reader.result);
				dispatch({
					type: MAIN_FORM_PREPARATION_FILE,
					payload: data
				});
			};
		},

		uploadFile: (accountId, fileToUpload, dispatch) => {
			const request = http({
				url: endpoints.BM_ACCOUNTS.UPLOAD_IMAGE.replace('{id}', accountId),
				method: 'put',
				actions: [MAIN_FORM_UPLOAD_SUCCESS, MAIN_FORM_UPLOAD_ERROR],
				data: fileToUpload
			});

			dispatch(parentActions.toggleProgressBar());

			request(dispatch)
				.then(action => {
					if (action.type === MAIN_FORM_UPLOAD_SUCCESS) {
						dispatch(parentActions.fetchData(action.payload.data.id));
						dispatch(parentActions.toggleProgressBar());
					}
				});
		}

	};

	const reducers = {
		[MAIN_FORM_SUBMIT_ERROR]: errorReducerFn,
		[MAIN_FORM_UPLOAD_ERROR]: errorReducerFn,
		[MAIN_FORM_PREPARATION_FILE]: (state, action) => ({
			...state,
			mainForm: {
				...state.mainForm,
				fileToUpload: action.payload
			}
		}),
		[MAIN_FORM_CHANGE_LANGUAGE]: (state, action) => ({
			...state,
			mainForm: {
				...state.mainForm,
				currentLanguage: action.payload
			}
		})
	};

	const selectors = {
		getCurrentLanguage: _pathOr('en', ['bmAccountsEditor', 'mainForm', 'currentLanguage']),
		getMainFormData: state => {
			const { data: account } = state.bmAccountsEditor;
			const categoryName = _pathOr('', 'category_name', account);
			const categoryId = _pathOr('', 'category_id', account);
			const currency = _pathOr('', 'currency', account);
			const selectedCurrency = createSelectOptionsFromSysEnums(
				state.root.lists['available-currencies']
			).find(ro => ro.value === currency);
			return {
				initialValues: {
					...state.bmAccountsEditor.data,
					category: categoryName && [{
						value: categoryId,
						label: categoryName
					}],
					currency: selectedCurrency && [selectedCurrency]
				}
			};
		}
	};

	return {
		initialState,
		actions,
		reducers,
		selectors
	};
};

export default createGeneralForm;



// WEBPACK FOOTER //
// ./frontend/admin-dashboard/src/modules/bm-accounts/components/forms/general/index.js